module.exports = __webpack_public_path__ + "images/quingoa5899c4be5cf468e887eec25667f5fbb.png";